import { AppFragment } from 'enums/path-fragment';
import { shallowEqual } from 'fast-equals';
import { RootState } from 'lib/centralStore';
import { createSelector } from 'reselect';
import { isTruthy } from 'utility/functions';

const _self = ({ configuration }: RootState) => configuration ?? {};

export const selectApps = createSelector(_self, (state) => state.apps);
export const selectSmartBanner = createSelector(_self, (state) => state.selectedBanner);
export const selectModalTutorial = createSelector([_self], ({ modalTutorial }) => modalTutorial);
export const selectIsEnabledTrace = createSelector([_self], ({ isEnabledTrace }) => isTruthy(isEnabledTrace));
export const selectIsActiveIppica = createSelector([_self], ({ isActiveIppica }) => isTruthy(isActiveIppica));
export const selectIsActiveVirtual = createSelector([_self], ({ isActiveVirtual }) => isTruthy(isActiveVirtual));
export const selectIsActiveAvatars = createSelector([_self], ({ isActiveAvatars }) => isTruthy(isActiveAvatars));
export const selectWebSocketInterval = createSelector([_self], ({ webSocketInterval }) => webSocketInterval ?? 0);
export const selectBetReferralTiming = createSelector([_self], ({ betReferralTiming }) => betReferralTiming ?? 15);
export const selectIsActiveMarcatori = createSelector([_self], ({ isActiveMarcatori }) => isTruthy(isActiveMarcatori));
export const selectIsActiveStreaming = createSelector([_self], ({ isActiveStreaming }) => isTruthy(isActiveStreaming));
export const selectIsActiveBingoLive = createSelector([_self], ({ isActiveBingoLive }) => isTruthy(isActiveBingoLive));
export const selectIsSportSearchEnabled = createSelector([_self], ({ isSportSearchEnabled }) =>
  isTruthy(isSportSearchEnabled)
);
export const selectIsNewBingoLaunchActive = createSelector([_self], ({ isNewBingoLaunchActive }) =>
  isTruthy(isNewBingoLaunchActive)
);
export const selectTransferToCustomerCard = createSelector([_self], ({ transferToCustomercard }) =>
  isTruthy(transferToCustomercard)
);
export const selectTransferFromCustomerCard = createSelector([_self], ({ transferFromCustomercard }) =>
  isTruthy(transferFromCustomercard)
);
export const selectIsActiveDiminuzioneImporto = createSelector([_self], ({ isActiveDiminuzioneImporto }) =>
  isTruthy(isActiveDiminuzioneImporto)
);
export const selectIsActiveFantawinner = createSelector([_self], ({ isActiveFantawinner }) =>
  isTruthy(isActiveFantawinner)
);
export const selectIsActiveTopLive = createSelector([_self], ({ isActiveTopLive }) => isTruthy(isActiveTopLive));

export const selectSignalRConfiguration = createSelector([_self], ({ signalrConfiguration }) => signalrConfiguration);

export const selectRedirectConfig = createSelector(
  [_self],
  ({
    mobileRedirectLive,
    mobileRedirectSport,
    mobileRedirectIppica,
    mobileRedirectVirtual,
  }): Record<string, boolean> => {
    const result: Record<string, boolean> = {};
    result[AppFragment.Live] = isTruthy(mobileRedirectLive);
    result[AppFragment.Sport] = isTruthy(mobileRedirectSport);
    result[AppFragment.Ippica] = isTruthy(mobileRedirectIppica);
    result[AppFragment.Virtuali] = isTruthy(mobileRedirectVirtual);
    return result;
  },
  { memoizeOptions: { resultEqualityCheck: shallowEqual } }
);
export const selectMobileRedirectLive = createSelector([selectRedirectConfig], (data) => data[AppFragment.Live], {
  memoizeOptions: { resultEqualityCheck: shallowEqual },
});
export const selectMobileRedirectSport = createSelector([selectRedirectConfig], (data) => data[AppFragment.Sport], {
  memoizeOptions: { resultEqualityCheck: shallowEqual },
});
export const selectMobileRedirectIppica = createSelector([selectRedirectConfig], (data) => data[AppFragment.Ippica], {
  memoizeOptions: { resultEqualityCheck: shallowEqual },
});
export const selectMobileRedirectVirtual = createSelector(
  [selectRedirectConfig],
  (data) => data[AppFragment.Virtuali],
  { memoizeOptions: { resultEqualityCheck: shallowEqual } }
);
